import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../theme";

import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

// ✅ أضفنا icon ضمن الخصائص (props) المستلمة
const StatBox = ({ title, subtitle, priceData, icon }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { current, previous } = priceData;
  const isMobile = useMediaQuery("(max-width:600px)");

  // السعر زاد أو استقر (لعدم إظهار سهم أحمر إذا كان السعر ثابتاً)
  const isPriceIncreased = current >= previous;

  const priceChangeIcon = isPriceIncreased ? (
    <ArrowUpwardIcon
      sx={{
        color: colors.greenAccent[500],
        fontSize: isMobile ? "20px" : "28px",
      }}
    />
  ) : (
    <ArrowDownwardIcon
      sx={{
        color: colors.redAccent[500],
        fontSize: isMobile ? "20px" : "28px",
      }}
    />
  );

  return (
    <Box
      width="100%"
      height="100px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Box display="flex" alignItems="center" gap="10px" mb="6px" ml="10px">
        {/* ✅ عرض الأيقونة الممررة من الملف الرئيسي مباشرة هنا */}
        {icon}

        <Typography
          fontWeight="bold"
          sx={{
            color: colors.grey[100],
            fontSize: isMobile ? "20px" : "32px", // تم تصغير الخط قليلاً ليتناسب مع الأيقونات الجديدة
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px="20px"
      >
        <Typography
          sx={{
            color: isPriceIncreased
              ? colors.greenAccent[500]
              : colors.redAccent[500],
            fontSize: isMobile ? "16px" : "25px",
            fontWeight: "bold",
          }}
        >
          {subtitle}
        </Typography>
        {priceChangeIcon}
      </Box>
    </Box>
  );
};

export default StatBox;
